import { useAtom } from "jotai";
import { modalAtom, openAtom} from "../context";

export const useDocumentModal = () => {
  const [, setModal] = useAtom(modalAtom);
  const [, setOpen] = useAtom(openAtom);

  const viewDocument = (title: string, path: string) => {
    setModal({
      header: title,
      content: (
        <iframe
          src={path}
          title={title}
          style={{
            width: "100%",
            height: "80vh",
            border: "none",
          }}
        />
      ),
    });

    setOpen(true);
  };

  return { viewDocument };
};
